import ModuleOverview from '@/common/containers/ModuleOverview/ModuleOverview';

export default ModuleOverview;
